import { useMemo } from "react";
import backendApiClient from "../api/backendApiClient";
import { useApiWithClient } from "./useApiWithClient";

export const useBackend = () => {
  const backendClient = useMemo(() => backendApiClient(true, true, null), []);
  return useApiWithClient(backendClient, "backend");
};
